import React from 'react'
import { Image, Linking, StyleSheet, TouchableOpacity, View } from 'react-native'
import { Icon, Text, useTheme } from '@ui-kitten/components'

const isImage = (contentType) => typeof contentType === 'string' && contentType.startsWith('image/')

export default function AttachmentChip({ attachment, onRemove }) {
  const theme = useTheme()
  const { url, uri, filename, name, contentType, type } = attachment
  const src = url || uri
  const label = filename || name || 'file'
  const mime = contentType || type || ''

  const open = () => {
    if (url) {
      Linking.openURL(url).catch(() => {})
    }
  }

  return (
    <View style={[styles.chip, { backgroundColor: theme['background-basic-color-2'] }]}>
      {isImage(mime) && src ? (
        <TouchableOpacity onPress={open} accessibilityRole="imagebutton" accessibilityLabel={label}>
          <Image source={{ uri: src }} style={styles.thumb} resizeMode="cover" />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.fileRow} onPress={open} accessibilityRole="button" accessibilityLabel={label}>
          <Icon name="file-text-outline" fill={theme['text-hint-color']} style={styles.fileIcon} />
          <Text category="c1" numberOfLines={1} style={styles.fileName}>
            {label}
          </Text>
        </TouchableOpacity>
      )}
      {onRemove ? (
        <TouchableOpacity style={styles.remove} onPress={onRemove} accessibilityRole="button" accessibilityLabel="Remove attachment">
          <Icon name="close-circle" fill={theme['text-hint-color']} style={styles.removeIcon} />
        </TouchableOpacity>
      ) : null}
    </View>
  )
}

const styles = StyleSheet.create({
  chip: { borderRadius: 8, overflow: 'hidden', marginRight: 8, marginTop: 6 },
  thumb: { width: 120, height: 120, borderRadius: 8 },
  fileRow: { flexDirection: 'row', alignItems: 'center', padding: 10, maxWidth: 200 },
  fileIcon: { width: 20, height: 20, marginRight: 6 },
  fileName: { flexShrink: 1 },
  remove: { position: 'absolute', top: 2, right: 2 },
  removeIcon: { width: 18, height: 18 },
})
